import type { LinksConfig } from '@Interfaces/Constants/LinksInterface'

export const Links = {
  // Auth (New)
  NewLogin: '/',
  NewCreateCorporateAccount: '/new-create-corporate-account',
  NewPersonalLogin: '/new-personal-login',
  NewEnterPasscode: '/new-enter-passcode',
  NewSetupPersonalAccount: '/new-setup-personal-account',
  NewVerifyYourAccount: '/new-verify-your-account',
  NewConfirmYourAccount: '/new-confirm-your-account',
  NewCongrats: '/new-congrats',
  NewSetupCorporateAccount: '/new-setup-corporate-account',
  NewSetupNonprofitAccount: '/new-setup-nonprofit-account',
  NewPayForYourPlan: '/new-pay-for-your-plan',
  NewDashboardLive: '/new-dashboard-live',
  // Nonprofit Auth (New)
  NewCreateNonprofitAccount: '/new-create-nonprofit-account',
  NewGetVerified: '/new-get-verified',
  NewReviewingDocuments: '/new-reviewing-documents',
  NewConnectStripe: '/new-connect-stripe',

  /** In-app Storybook iframe; static build served at same path (see `isStorybookInAppRouteEnabled`) */
  Storybook: '/storybook',

  // Landing: "/",
  CreateAccount: '/create-account',
  PersonalLogin: '/personal-login',
  CreatePersonalAccount: '/create-personal-account',
  VerifyPersonalAccount: '/verify-personal-account',
  EnterPasscode: '/enter-passcode',
  PersonalInformation: '/personal-information',
  Congrats: '/success-personal-account',
  CorporateAccount: '/corporate-account',
  AccountCreated: '/account-created',
  VerifyNonProfit: '/verify-non-profit',
  Verifying: '/verifying',
  AccountCreatedStep2: '/account-created-step2',

  Dashboard: '/dashboard',
  Team: '/team',

  Donations: '/donations',

  DonorDetails: '/donor-details',
  BusinessDonorDetails: '/b-donor-details',
  Fundraising: '/fundraising',
  FundraisingDetail: '/fundraisingDetail',
  CustomLinks: '/customLinks',
  CustomLinkDetails: '/customLinkDetails',
  OnlineGiving: '/online-giving',
  UserDetails: '/userDetails',
  Events: '/events',
  EventDetail: '/eventDetail',
  Opportunities: '/opportunities',

  Settings: '/settings',

  Support: '/support',

  //businesses
  BusinessDashboard: '/b-Dashboard',
  RayzeWallet: '/b-rayze-wallet',
  BusinessEmployees: '/employees',
  BusinessEmployeeDetail: '/employee-detail',
  BusinessDonations: '/b-donations',
  BusinessVolunteers: '/b-volunteers',
  BusinessCampaigns: '/b-campaigns',
  BusinessCampaignDetails: '/b-campaign-details',

  //nonprofits
  Nonprofits: '/nonprofits',
  NonprofitDetail: '/nonprofit-detail',

  GeneralSettings: '/b-settings',

  //businesses invite
  BusinessInviteLanding: '/invite-0',
  InvitePasscode: '/invite-1',
  InviteNewOrExistingAccount: '/invite-2',
  InviteNewAccount: '/invite-3',
  InviteExistingAccount: '/invite-4',
} as const satisfies LinksConfig
